import { css } from '@emotion/react';
import { DropdownItemComponent } from '~/_shared/baseComponents/dropdown';
import { InputSize } from '~/_shared/baseComponents/inputs';
import { LabelInCircleComponent } from '~/_shared/baseComponents/labelInShape/labelInCircleComponent';
import { type ActiveBoundaryFillInfoEntities } from '~/sidebar/sidebarApps/mapTools/boundary/hooks/useGetBoundaryFillEntities';
import { BoundaryKeyHeaderInfoComponent } from '~/sidebar/sidebarApps/rightSidebar/masterKey/boundaryKey/BoundaryKeyHeaderInfo.component';

const fillDropDownOptionStyles = css({
  minWidth: '100%',
  paddingInline: 10,
  height: 'auto',
  lineHeight: 'normal',
  paddingBlock: 2,
});

const optionWrapperStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});

const numberInCircleStyles = css({
  fontSize: 14,
});

type ActiveBoundaryDropdownOptionProps = Readonly<{
  entities: ActiveBoundaryFillInfoEntities;
  fillOrderNumber: number | null;
  backgroundColor: string;
  foregroundColor: string;
  onClick: () => void;
}>;

export const ActiveBoundaryDropdownOptionComponent = ({
  entities,
  fillOrderNumber,
  backgroundColor,
  foregroundColor,
  onClick,
}: ActiveBoundaryDropdownOptionProps) => {
  const { mainEntity, shortenedSubEntity } = entities;

  if (fillOrderNumber === null) {
    return null;
  }

  return (
    <DropdownItemComponent
      css={fillDropDownOptionStyles}
      name=""
      onClick={onClick}
      prefix={(
        <div css={optionWrapperStyles}>
          <LabelInCircleComponent
            css={numberInCircleStyles}
            colors={{
              fillColor: backgroundColor,
              fontColor: foregroundColor,
            }}
            size={18}
          >
            {fillOrderNumber}
          </LabelInCircleComponent>
          <BoundaryKeyHeaderInfoComponent
            mainEntity={mainEntity}
            shortenedSubEntity={shortenedSubEntity}
          />
        </div>
      )}
      size={InputSize.Small}
    />
  );
};
